import { Either, getEq } from "fp-ts/lib/Either";
import { Eq } from "fp-ts/lib/Eq";

export type Defaultable<T> = Either<T, T>;

export const eqDefault = <T>(eq: Eq<T>): Eq<Defaultable<T>> => getEq(eq, eq);
